import styled from "styled-components";
import { UiConstants } from "../../data/UiConstants";
export const Dropdown = styled.select.withConfig({
  displayName: "Dropdown",
  componentId: "sc-1i0zncz-0"
})(["&.invalid{outline:2px solid ", ";border-radius:2px;border-color:rgba(0,0,0,0);}&:focus{outline:2px solid ", ";border-radius:2px;border-color:rgba(0,0,0,0);}&:focus.invalid{outline:2px solid ", ";border-radius:2px;border-color:rgba(0,0,0,0);}"], UiConstants.COLOR_VALUE_INVALID, UiConstants.COLOR_SELECTION_HIGHLIGHT, UiConstants.COLOR_VALUE_INVALID);
export const DropdownWithMargin = styled(Dropdown).withConfig({
  displayName: "Dropdown__DropdownWithMargin",
  componentId: "sc-1i0zncz-1"
})(["margin:4px;"]);